var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"loading":_vm.loading,"disabled":_vm.loading}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("number_of_applicants_by_order_report.title"))+" ")]),_c('v-card-text',[_c('v-autocomplete',{attrs:{"label":_vm.$t('officer_config.academic_year'),"items":_vm.config_years,"item-value":(item) => item.YEAR_ID,"item-text":(item) => item.SEMESTER + ' / ' + item.YEAR,"outlined":"","dense":""},on:{"change":function($event){return _vm.update_year(_vm.year_id)}},model:{value:(_vm.year_id),callback:function ($$v) {_vm.year_id=$$v},expression:"year_id"}}),_c('v-autocomplete',{attrs:{"label":_vm.$t('officer_config.faculty'),"items":_vm.registrar_faculties,"item-value":(item) => item.FACULTY_ID,"item-text":(item) => _vm.objectTranslator(item, 'FACULTY_NAME'),"outlined":"","dense":""},on:{"change":function($event){return _vm.update_faculty()}},model:{value:(_vm.selected_registrar_faculty_id),callback:function ($$v) {_vm.selected_registrar_faculty_id=$$v},expression:"selected_registrar_faculty_id"}}),(_vm.selected_registrar_faculty_id !== null)?_c('v-autocomplete',{attrs:{"label":_vm.$t('program_list.round'),"items":_vm.available_rounds,"item-value":(item) => item.ROUND_ID,"item-text":(item) => _vm.objectTranslator(item, 'ROUND_NAME'),"outlined":"","dense":""},on:{"change":function($event){return _vm.update_round()}},model:{value:(_vm.selected_round_id),callback:function ($$v) {_vm.selected_round_id=$$v},expression:"selected_round_id"}}):_vm._e(),(_vm.level_id === '2' || _vm.level_id === '3')?_c('v-autocomplete',{attrs:{"label":_vm.$t('officer_config.admit_type'),"items":_vm.admit_types,"item-value":(item) => item.STUDY_ADMIT_TYPE_ID,"item-text":(item) => _vm.objectTranslator(item, 'STUDY_ADMIT_TYPE_NAME'),"clearable":"","outlined":"","dense":""},model:{value:(_vm.study_admit_type_id),callback:function ($$v) {_vm.study_admit_type_id=$$v},expression:"study_admit_type_id"}}):_vm._e(),(_vm.level_id === '2' || _vm.level_id === '3')?_c('v-autocomplete',{attrs:{"label":_vm.$t('officer_config.study_plan'),"items":_vm.programs,"item-value":(item) => item.STUDY_PLAN_ID,"item-text":(item) => _vm.objectTranslator(item, 'STUDY_PLAN_NAME'),"clearable":"","outlined":"","dense":""},model:{value:(_vm.study_plan_id),callback:function ($$v) {_vm.study_plan_id=$$v},expression:"study_plan_id"}}):_vm._e(),(_vm.level_id === '2' || _vm.level_id === '3')?_c('v-autocomplete',{attrs:{"label":_vm.$t('officer_config.study_classes'),"items":_vm.classes,"item-value":(item) => item.STUDY_CLASSES_ID,"item-text":(item) => _vm.objectTranslator(item, 'STUDY_CLASSES_NAME'),"clearable":"","outlined":"","dense":""},model:{value:(_vm.study_classes_id),callback:function ($$v) {_vm.study_classes_id=$$v},expression:"study_classes_id"}}):_vm._e(),(_vm.level_id === '2' || _vm.level_id === '3')?_c('v-autocomplete',{attrs:{"label":_vm.$t('officer_config.specific_nation'),"items":_vm.specific_nations,"item-value":(item) => item.SPECIFIC_NATION_ID,"item-text":(item) => _vm.objectTranslator(item, 'SPECIFIC_NATION_NAME'),"clearable":"","outlined":"","dense":""},model:{value:(_vm.specific_nation_id),callback:function ($$v) {_vm.specific_nation_id=$$v},expression:"specific_nation_id"}}):_vm._e(),(_vm.selected_round_id !== null)?_c('span',{staticClass:"teal--text"},[_vm._v("* การคัดเลือกผู้ผ่านต้องเลือกแบบแยกโครงการ และแยกหลักสูตร")]):_vm._e(),(_vm.selected_round_id !== null)?_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"label":_vm.$t('number_of_applicants_report.all_project')},model:{value:(_vm.use_all_project),callback:function ($$v) {_vm.use_all_project=$$v},expression:"use_all_project"}}):_vm._e(),(!_vm.use_all_project && _vm.selected_round_id !== null)?_c('v-autocomplete',{attrs:{"label":_vm.$t('program_list.project'),"items":_vm.available_projects,"item-value":(item) => item.PROJECT_ID,"item-text":(item) => _vm.objectTranslator(item, 'PROJECT_NAME'),"outlined":"","dense":"","chips":"","clearable":"","deletable-chips":"","multiple":""},model:{value:(_vm.selected_project_ids),callback:function ($$v) {_vm.selected_project_ids=$$v},expression:"selected_project_ids"}}):_vm._e(),(
          _vm.selected_round_id !== null &&
          (_vm.use_all_project || _vm.selected_project_ids.length > 0)
        )?_c('div',[_c('v-divider'),_vm._l((_vm.use_all_project
            ? _vm.all_filtered_curriculums
            : _vm.some_filtered_curriculums),function(project){return _c('div',{key:project.NAME_EN},[_c('h2',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.objectTranslator(project, "NAME")))]),_c('v-simple-table',{staticClass:"mb-5",attrs:{"dense":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.$t("number_of_applicants_report.curriculum"))+" ")]),_c('th',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.$t( "number_of_applicants_by_order_report.select_order_1" ))+" ")]),_c('th',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.$t( "number_of_applicants_by_order_report.select_order_2" ))+" ")]),_c('th',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.$t( "number_of_applicants_by_order_report.select_order_3" ))+" ")])])]),_c('tbody',[_vm._l((project.table),function(list){return _vm._l((list),function(item){return _c('tr',{key:item.CURRICULUM_NAME_TH + item.BRANCH_NAME_TH},[_c('td',{staticClass:"text-left"},[_vm._v(" "+_vm._s(_vm.objectTranslator(item, "CURRICULUM_NAME"))+" "),(item.BRANCH_NAME_TH)?_c('span',{staticClass:"deep-orange--text"},[_vm._v(" "+_vm._s(_vm.$t("number_of_applicants_by_order_report.branch"))+" "+_vm._s(_vm.objectTranslator(item, "BRANCH_NAME"))+" ")]):_vm._e()]),_c('td',{staticClass:"text-right"},[_c('router-link',{attrs:{"target":"_blank","to":{
                          name: 'applicants_report_list',
                          query: {
                            level_id: _vm.level_id,
                            year_id: _vm.year_id,
                            project_id: project.project_id,
                            round_id: _vm.selected_round_id,
                            curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                            admission_curriculum_id: item.CURRICULUM_ID,
                            branch_id: item.BRANCH_ID,

                            study_admit_type_id: _vm.study_admit_type_id
                              ? _vm.study_admit_type_id
                              : null,
                            study_plan_id: _vm.study_plan_id
                              ? _vm.study_plan_id
                              : null,
                            study_classes_id: _vm.study_classes_id
                              ? _vm.study_classes_id
                              : null,
                            specific_nation_id: _vm.specific_nation_id
                              ? _vm.specific_nation_id
                              : null,

                            status: '0',
                            order: '1',
                            faculty_id: _vm.selected_registrar_faculty_id,

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.NAME_TH,
                            PROJECT_NAME_EN: project.NAME_EN,
                            ROUND_NAME_TH: item.ROUND_NAME_TH,
                            ROUND_NAME_EN: item.ROUND_NAME_EN,
                            FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                            CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                            BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                            BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                            STUDY_ADMIT_TYPE_NAME_EN:
                              item.STUDY_ADMIT_TYPE_NAME_EN,
                            STUDY_ADMIT_TYPE_NAME_TH:
                              item.STUDY_ADMIT_TYPE_NAME_TH,
                            STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                            STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                            STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                            STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                            SPECIFIC_NATION_NAME_EN:
                              item.SPECIFIC_NATION_NAME_EN,
                            SPECIFIC_NATION_NAME_TH:
                              item.SPECIFIC_NATION_NAME_TH,

                            TYPE_DATA_TH: 'เลือกเป็นอันดับ 1',
                            TYPE_DATA_EN: 'The first order',
                            COUNT_TOTAL: item.sum_s1,

                            selective_mode: true,
                          },
                        }}},[_vm._v(" "+_vm._s(item.sum_s1)+" ")])],1),_c('td',{staticClass:"text-right"},[_c('router-link',{attrs:{"target":"_blank","to":{
                          name: 'applicants_report_list',
                          query: {
                            level_id: _vm.level_id,
                            year_id: _vm.year_id,
                            project_id: project.project_id,
                            round_id: _vm.selected_round_id,
                            curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                            admission_curriculum_id: item.CURRICULUM_ID,
                            branch_id: item.BRANCH_ID,

                            study_admit_type_id: _vm.study_admit_type_id
                              ? _vm.study_admit_type_id
                              : null,
                            study_plan_id: _vm.study_plan_id
                              ? _vm.study_plan_id
                              : null,
                            study_classes_id: _vm.study_classes_id
                              ? _vm.study_classes_id
                              : null,
                            specific_nation_id: _vm.specific_nation_id
                              ? _vm.specific_nation_id
                              : null,

                            status: '0',
                            order: '2',
                            faculty_id: _vm.selected_registrar_faculty_id,

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.NAME_TH,
                            PROJECT_NAME_EN: project.NAME_EN,
                            ROUND_NAME_TH: item.ROUND_NAME_TH,
                            ROUND_NAME_EN: item.ROUND_NAME_EN,
                            FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                            CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                            BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                            BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                            STUDY_ADMIT_TYPE_NAME_EN:
                              item.STUDY_ADMIT_TYPE_NAME_EN,
                            STUDY_ADMIT_TYPE_NAME_TH:
                              item.STUDY_ADMIT_TYPE_NAME_TH,
                            STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                            STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                            STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                            STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                            SPECIFIC_NATION_NAME_EN:
                              item.SPECIFIC_NATION_NAME_EN,
                            SPECIFIC_NATION_NAME_TH:
                              item.SPECIFIC_NATION_NAME_TH,

                            TYPE_DATA_TH: 'เลือกเป็นอันดับ 2',
                            TYPE_DATA_EN: 'The second order',
                            COUNT_TOTAL: item.sum_s2,

                            selective_mode: true,
                          },
                        }}},[_vm._v(" "+_vm._s(item.sum_s2)+" ")])],1),_c('td',{staticClass:"text-right"},[_c('router-link',{attrs:{"target":"_blank","to":{
                          name: 'applicants_report_list',
                          query: {
                            level_id: _vm.level_id,
                            year_id: _vm.year_id,
                            project_id: project.project_id,
                            round_id: _vm.selected_round_id,
                            curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                            admission_curriculum_id: item.CURRICULUM_ID,
                            branch_id: item.BRANCH_ID,

                            study_admit_type_id: _vm.study_admit_type_id
                              ? _vm.study_admit_type_id
                              : null,
                            study_plan_id: _vm.study_plan_id
                              ? _vm.study_plan_id
                              : null,
                            study_classes_id: _vm.study_classes_id
                              ? _vm.study_classes_id
                              : null,
                            specific_nation_id: _vm.specific_nation_id
                              ? _vm.specific_nation_id
                              : null,

                            status: '0',
                            order: '3',
                            faculty_id: _vm.selected_registrar_faculty_id,

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.NAME_TH,
                            PROJECT_NAME_EN: project.NAME_EN,
                            ROUND_NAME_TH: item.ROUND_NAME_TH,
                            ROUND_NAME_EN: item.ROUND_NAME_EN,
                            FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                            CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                            BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                            BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                            STUDY_ADMIT_TYPE_NAME_EN:
                              item.STUDY_ADMIT_TYPE_NAME_EN,
                            STUDY_ADMIT_TYPE_NAME_TH:
                              item.STUDY_ADMIT_TYPE_NAME_TH,
                            STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                            STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                            STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                            STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                            SPECIFIC_NATION_NAME_EN:
                              item.SPECIFIC_NATION_NAME_EN,
                            SPECIFIC_NATION_NAME_TH:
                              item.SPECIFIC_NATION_NAME_TH,

                            TYPE_DATA_TH: 'เลือกเป็นอันดับ 3',
                            TYPE_DATA_EN: 'The third order',
                            COUNT_TOTAL: item.sum_s3,

                            selective_mode: true,
                          },
                        }}},[_vm._v(" "+_vm._s(item.sum_s3)+" ")])],1)])})}),_c('tr',[_c('td',{staticClass:"text-left font-weight-black indigo--text"},[_vm._v(" "+_vm._s(_vm.$t("number_of_applicants_report.summary"))+" ")]),_c('td',{staticClass:"text-right font-weight-black indigo--text"},[_c('router-link',{attrs:{"target":"_blank","to":{
                        name: 'applicants_report_list',
                        query: {
                          level_id: _vm.level_id,
                          year_id: _vm.year_id,
                          project_id: project.project_id,
                          round_id: _vm.selected_round_id,
                          faculty_id: _vm.selected_registrar_faculty_id,

                          study_admit_type_id: _vm.study_admit_type_id
                            ? _vm.study_admit_type_id
                            : null,
                          study_plan_id: _vm.study_plan_id ? _vm.study_plan_id : null,
                          study_classes_id: _vm.study_classes_id
                            ? _vm.study_classes_id
                            : null,
                          specific_nation_id: _vm.specific_nation_id
                            ? _vm.specific_nation_id
                            : null,

                          status: '0',
                          order: '1',
                          faculty_id: _vm.selected_registrar_faculty_id,

                          YEAR: project.YEAR,
                          SEMESTER: project.SEMESTER,
                          PROJECT_NAME_TH: project.NAME_TH,
                          PROJECT_NAME_EN: project.NAME_EN,
                          ROUND_NAME_TH: project.ROUND_NAME_TH,
                          ROUND_NAME_EN: project.ROUND_NAME_EN,
                          FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                          FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                          CURRICULUM_NAME_TH: 'ทุกหลักสูตร',
                          CURRICULUM_NAME_EN: 'All Curriculum',

                          STUDY_ADMIT_TYPE_NAME_EN: _vm.study_admit_type_id
                            ? project.STUDY_ADMIT_TYPE_NAME_EN
                            : '-',
                          STUDY_ADMIT_TYPE_NAME_TH: _vm.study_admit_type_id
                            ? project.STUDY_ADMIT_TYPE_NAME_TH
                            : '-',
                          STUDY_PLAN_NAME_EN: _vm.study_plan_id
                            ? project.STUDY_PLAN_NAME_EN
                            : '-',
                          STUDY_PLAN_NAME_TH: _vm.study_plan_id
                            ? project.STUDY_PLAN_NAME_TH
                            : '-',
                          STUDY_CLASSES_NAME_EN: _vm.study_classes_id
                            ? project.STUDY_CLASSES_NAME_EN
                            : '-',
                          STUDY_CLASSES_NAME_TH: _vm.study_classes_id
                            ? project.STUDY_CLASSES_NAME_TH
                            : '-',
                          SPECIFIC_NATION_NAME_EN: _vm.specific_nation_id
                            ? project.SPECIFIC_NATION_NAME_EN
                            : '-',
                          SPECIFIC_NATION_NAME_TH: _vm.specific_nation_id
                            ? project.SPECIFIC_NATION_NAME_TH
                            : '-',

                          TYPE_DATA_TH: 'เลือกเป็นอันดับ 1',
                          TYPE_DATA_EN: 'The first order',
                          COUNT_TOTAL: project.sum_sum_s1,

                          selective_mode: true,
                        },
                      }}},[_vm._v(" "+_vm._s(project.sum_sum_s1)+" ")])],1),_c('td',{staticClass:"text-right font-weight-black indigo--text"},[_c('router-link',{attrs:{"target":"_blank","to":{
                        name: 'applicants_report_list',
                        query: {
                          level_id: _vm.level_id,
                          year_id: _vm.year_id,
                          project_id: project.project_id,
                          round_id: _vm.selected_round_id,
                          faculty_id: _vm.selected_registrar_faculty_id,

                          study_admit_type_id: _vm.study_admit_type_id
                            ? _vm.study_admit_type_id
                            : null,
                          study_plan_id: _vm.study_plan_id ? _vm.study_plan_id : null,
                          study_classes_id: _vm.study_classes_id
                            ? _vm.study_classes_id
                            : null,
                          specific_nation_id: _vm.specific_nation_id
                            ? _vm.specific_nation_id
                            : null,

                          status: '0',
                          order: '2',

                          YEAR: project.YEAR,
                          SEMESTER: project.SEMESTER,
                          PROJECT_NAME_TH: project.NAME_TH,
                          PROJECT_NAME_EN: project.NAME_EN,
                          ROUND_NAME_TH: project.ROUND_NAME_TH,
                          ROUND_NAME_EN: project.ROUND_NAME_EN,
                          FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                          FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                          CURRICULUM_NAME_TH: 'ทุกหลักสูตร',
                          CURRICULUM_NAME_EN: 'All Curriculum',

                          STUDY_ADMIT_TYPE_NAME_EN: _vm.study_admit_type_id
                            ? project.STUDY_ADMIT_TYPE_NAME_EN
                            : '-',
                          STUDY_ADMIT_TYPE_NAME_TH: _vm.study_admit_type_id
                            ? project.STUDY_ADMIT_TYPE_NAME_TH
                            : '-',
                          STUDY_PLAN_NAME_EN: _vm.study_plan_id
                            ? project.STUDY_PLAN_NAME_EN
                            : '-',
                          STUDY_PLAN_NAME_TH: _vm.study_plan_id
                            ? project.STUDY_PLAN_NAME_TH
                            : '-',
                          STUDY_CLASSES_NAME_EN: _vm.study_classes_id
                            ? project.STUDY_CLASSES_NAME_EN
                            : '-',
                          STUDY_CLASSES_NAME_TH: _vm.study_classes_id
                            ? project.STUDY_CLASSES_NAME_TH
                            : '-',
                          SPECIFIC_NATION_NAME_EN: _vm.specific_nation_id
                            ? project.SPECIFIC_NATION_NAME_EN
                            : '-',
                          SPECIFIC_NATION_NAME_TH: _vm.specific_nation_id
                            ? project.SPECIFIC_NATION_NAME_TH
                            : '-',

                          TYPE_DATA_TH: 'เลือกเป็นอันดับ 2',
                          TYPE_DATA_EN: 'The second order',
                          COUNT_TOTAL: project.sum_sum_s2,

                          selective_mode: true,
                        },
                      }}},[_vm._v(" "+_vm._s(project.sum_sum_s2)+" ")])],1),_c('td',{staticClass:"text-right font-weight-black indigo--text"},[_c('router-link',{attrs:{"target":"_blank","to":{
                        name: 'applicants_report_list',
                        query: {
                          level_id: _vm.level_id,
                          year_id: _vm.year_id,
                          project_id: project.project_id,
                          round_id: _vm.selected_round_id,
                          faculty_id: _vm.selected_registrar_faculty_id,

                          study_admit_type_id: _vm.study_admit_type_id
                            ? _vm.study_admit_type_id
                            : null,
                          study_plan_id: _vm.study_plan_id ? _vm.study_plan_id : null,
                          study_classes_id: _vm.study_classes_id
                            ? _vm.study_classes_id
                            : null,
                          specific_nation_id: _vm.specific_nation_id
                            ? _vm.specific_nation_id
                            : null,

                          status: '0',
                          order: '3',

                          YEAR: project.YEAR,
                          SEMESTER: project.SEMESTER,
                          PROJECT_NAME_TH: project.NAME_TH,
                          PROJECT_NAME_EN: project.NAME_EN,
                          ROUND_NAME_TH: project.ROUND_NAME_TH,
                          ROUND_NAME_EN: project.ROUND_NAME_EN,
                          FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                          FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                          CURRICULUM_NAME_TH: 'ทุกหลักสูตร',
                          CURRICULUM_NAME_EN: 'All Curriculum',

                          STUDY_ADMIT_TYPE_NAME_EN: _vm.study_admit_type_id
                            ? project.STUDY_ADMIT_TYPE_NAME_EN
                            : '-',
                          STUDY_ADMIT_TYPE_NAME_TH: _vm.study_admit_type_id
                            ? project.STUDY_ADMIT_TYPE_NAME_TH
                            : '-',
                          STUDY_PLAN_NAME_EN: _vm.study_plan_id
                            ? project.STUDY_PLAN_NAME_EN
                            : '-',
                          STUDY_PLAN_NAME_TH: _vm.study_plan_id
                            ? project.STUDY_PLAN_NAME_TH
                            : '-',
                          STUDY_CLASSES_NAME_EN: _vm.study_classes_id
                            ? project.STUDY_CLASSES_NAME_EN
                            : '-',
                          STUDY_CLASSES_NAME_TH: _vm.study_classes_id
                            ? project.STUDY_CLASSES_NAME_TH
                            : '-',
                          SPECIFIC_NATION_NAME_EN: _vm.specific_nation_id
                            ? project.SPECIFIC_NATION_NAME_EN
                            : '-',
                          SPECIFIC_NATION_NAME_TH: _vm.specific_nation_id
                            ? project.SPECIFIC_NATION_NAME_TH
                            : '-',

                          TYPE_DATA_TH: 'เลือกเป็นอันดับ 3',
                          TYPE_DATA_EN: 'The third order',
                          COUNT_TOTAL: project.sum_sum_s3,

                          selective_mode: true,
                        },
                      }}},[_vm._v(" "+_vm._s(project.sum_sum_s3)+" ")])],1)])],2)]},proxy:true}],null,true)})],1)})],2):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }